<template>
  <div class="cherow text-noselect">
    <div class="cherow_title gw_hvr">
      <slot
        name="title"
        :item="item"
      >
        {{ item.title }}

        <div
          v-if="item.title_tooltip"
          class="mdi gw_hvr_content mdi-help-circle-outline text-small my-auto ml-1 csst"
          style="color: var(--clr-grey-2); --hvr-content-opacity: 0.5"
          @mouseenter="
            e => {
              fl_positionTooltip(e, { offset: 0, placement: 'top' })
            }
          "
        >
          <div
            class="csst_content csst_content_hoverable clr-white"
            style="position: fixed; max-width: clamp(12rem, 36rem, 96vw)"
            v-html="item.title_tooltip"
          ></div>
        </div>
      </slot>
    </div>
    <!-- @mouseleave="handleLeave" -->
    <GwBtns
      :options="item.options"
      :disabled="item.disabled"
      :values="mousedown ? draggPreSelected : item.selected"
      :idKey="item.idKey"
      :style="btnsStyle || ''"
      style="
        --gwbtn-size: 1rem;
        --gwbtn-height: 1.875rem;
        --gwbtns-wrap: wrap;
        --gwbtn-clr-active-white: var(--clr-black-3);
      "
      class="cherow_btns"
      :class="`${item.isSingle ? 'cherow_btns_single' : 'cherow_btns_multiple'}`"
      @mousedown="val => handleMousedown(val)"
      @mouseenter="val => handleMouseenter(val)"
      @mouseleave="val => handleMouseleave(val)"
      @click="
        (_e, val) =>
          handleClick({
            item: val,
            selected: item.selected,
          })
      "
    >
      <template #before>
        <div
          v-if="item.hasAny"
          class="gw_btn gwbtns_btn weight_500"
          style="
            --height: 1.875rem;
            --clr: var(--clr-grey-2);
            --clr-hover: var(--clr-white-0);
            --clr-active: var(--clr-white-0);
          "
          :class="{
            gw_btn_active: !item.selected.length,
          }"
          @click="handleAnyClick"
        >
          <slot
            name="btn_any"
            :item="item"
          >
            {{ item.anyAsOff ? $t(`btn.off`) : $t(`practice.filter.any`) }}
          </slot>
        </div>
      </template>
      <template #default="{ item }">
        <slot :item="item">
          {{ item }}
        </slot>
      </template>
    </GwBtns>
  </div>
</template>

<script>
import GwBtns from '@/components/lib/GwBtns'
import float_mix from '@/mixins/float_mix'
import { toggleArr } from '@/helpers/helpers'

export default {
  name: 'CheckboxRow',
  components: {
    GwBtns,
  },
  mixins: [float_mix],
  props: {
    item: {
      type: Object,
      default: () => ({
        // idKey: '',
        title: '',
        title_tooltip: '',
        options: [],
        disabled: [],
        selected: [],
        hasAny: true,
        isSingle: true,
        anyAsOff: false,
      }),
    },
    hasValueCheck: Boolean,
    btnsStyle: String,
  },
  emits: ['update'],
  data() {
    return {
      mousedown: false,
      draggPreSelected: null,
      addByDragging: false,
    }
  },
  beforeUnmount() {
    this.removeEventListeners()
  },
  methods: {
    removeEventListeners() {
      // console.log('removeEventListeners')
      window.removeEventListener('mouseup', this.handleMouseup)
    },
    handleMouseup() {
      this.emitUpdate({
        ...this.item,
        selected: this.draggPreSelected,
      })
      this.removeEventListeners()
      this.mousedown = false
      this.draggPreSelected = null
    },
    handleMousedown(item) {
      if (this.item.isSingle) return

      window.addEventListener('mouseup', this.handleMouseup)
      this.mousedown = true
      this.draggPreSelected = this.item.selected
      this.addByDragging = !this.item.selected.includes(item[this.idKey] || item)
    },
    handleMouseleave(item) {
      if (this.mousedown) {
        // so the first item is added when dragging starts
        this.handleMouseenter(item)
      }
    },
    handleMouseenter(item) {
      if (this.mousedown) {
        this.draggPreSelected = this.addByDragging
          ? [...new Set([...this.draggPreSelected, item[this.idKey] || item])]
          : this.draggPreSelected.filter(i => i !== (item[this.idKey] || item))
      }
    },
    handleClick({ item, selected }) {
      selected = this.item.isSingle ? [item] : toggleArr({ arr: selected, item })

      this.emitUpdate({
        ...this.item,
        selected,
      })
    },
    handleAnyClick() {
      this.emitUpdate({
        ...this.item,
        selected: [],
      })
    },
    emitUpdate(item) {
      this.$emit('update', item)
    },
  },
}
</script>
<style lang="scss" scoped>
.cherow {
  --cherow-title-clr: var(--clr-grey-2);
  --cherow-title-size: 0.875rem;
  --cherow-title-weight: 400;
  --cherow-title-margin: 0 0 0.25rem 0;
  --cherow-single-clrback: var(--clr-black-1-3);
  --cherow-multiple-clrback: transparent;

  display: flex;
  flex-direction: column;
  &_title {
    display: flex;
    align-items: center;
    position: relative;
    margin: var(--cherow-title-margin);
    font-size: var(--cherow-title-size);
    font-weight: var(--cherow-title-weight);
    color: var(--cherow-title-clr);
  }
  &_btns {
    margin-right: auto;
    border-radius: 4px;
    padding: 2px;
    &_single {
      background: var(--cherow-single-clrback);
    }
    &_multiple {
      background: var(--cherow-multiple-clrback);
    }
  }
}
</style>
